//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimezoneSelect",
  props: {
    timezone: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.timezone;
      },
      set(val) {
        this.$emit("update:timezone", val);
      }
    }
  },
  mounted() {
    this.initBetterTimezone();
  },
  methods: {
    initBetterTimezone() {
      this.$nextTick(() => {
        const timezoneSelect = $(this.$refs.timezoneSelect);
        timezoneSelect.on("change", event => {
          this.localValue = event.target.value;
        });
        timezoneSelect.betterTimezone({
          showIANA: true,
          showOptgroups: true,
          placeholder: this.$t("global.phrases.selectATimezone"),
          width: "style"
        });
      });
    }
  }
});